<template>
  <div
    v-show="isShowMobileMenu && !isDesktop"
    class="fixed bottom-0 left-0 z-page-menu h-full w-full bg-white pb-3 pt-32"
  >
    <nav class="h-full w-full overflow-y-auto overflow-x-hidden px-3">
      <ul
        :class="profile.hasMultipleAccounts && 'pb-change-role-mobile-height'"
      >
        <li
          v-for="item in navigation"
          :key="item.id"
          class="border-b border-solid border-gray-400 last:border-none"
        >
          <button
            class="block w-full py-3 text-left font-bold"
            :title="item.name"
            @click="handleClick(item.id)"
          >
            {{ item.name }}
          </button>
        </li>
        <slot name="items-side" />
      </ul>
    </nav>
  </div>
</template>

<script setup lang="ts">
  interface IProps {
    isShowMobileMenu: boolean;
    navigation: { id: string; name: string }[];
  }

  withDefaults(defineProps<IProps>(), {
    isShowMobileMenu: false,
    navigation: () => [],
  });

  const emits = defineEmits<{ (e: 'click-item-button'): void }>();

  const { isDesktop } = useScreen();
  const { headerHeight } = useWebsite();

  const { handleScrollTo } = useScrollTo({
    offset: headerHeight.value,
  });

  const profileStore = useProfileStore();
  const { profile } = storeToRefs(profileStore);

  const handleClick = (id: string): void => {
    handleScrollTo(id, headerHeight.value);
    emits('click-item-button');
  };
</script>
